// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wzy8","title":"styles_title__3U8Zg"};